import { useState } from "react"
import { useNavigate, Link } from "react-router-dom"
import { useLogin } from "../hooks/useAuth"
import { Eye, EyeOff } from "lucide-react"

export default function Login() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
   const [showPassword, setShowPassword] = useState(false)
  const navigate = useNavigate()
  const loginMutation = useLogin()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")

    try {
      const response = await loginMutation.mutateAsync({
        email,
        password,
      })

      localStorage.setItem("token", response.data.token)
      localStorage.setItem("user", JSON.stringify(response.data.user))
      navigate("/dashboard")
    } catch (err) {
      setError(err.response?.data?.message || "Login failed")
    }
  }

  return (
    <>
    {/* <img src="/images/minati-logo.png" alt="minatilogo" /> */}
<div className="relative min-h-screen flex items-center justify-end p-4 xl:pr-64 lg:pr-14 overflow-hidden">
  
  <video
    className="absolute top-0 left-0 w-full h-full object-cover"
    src="/images/login-bg.mp4"  
    autoPlay
    loop
    muted
    playsInline
  />

  <div className="absolute inset-0 bg-black/40"></div>

  <div className="relative z-10 auth-card">
    <div className="text-center mb-8">
      <h1 className="text-xl lg:text-4xl font-bold mb-2">
        <span className="text-accent">LOGIN</span>
      </h1>
      <p className="text-text-secondary">Welcome back to Minati</p>
    </div>

    {error && <div className="error-message">{error}</div>}

    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label className="form-label">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="form-input"
          placeholder="Enter Email....."
        />
      </div>

      <div>
        <div className="flex items-center justify-between mb-2">
          <label className="form-label mb-0">Password</label>
          <Link
            to="/forgot-password"
            className="text-sm text-accent-cyan hover:text-accent-bright-cyan transition-colors"
          >
            Forgot Password?
          </Link>
        </div>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="form-input pr-10"
            placeholder="••••••••"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
      </div>

      <button
        type="submit"
        disabled={loginMutation.isLoading}
        className="btn-primary w-full text-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loginMutation.isLoading ? "Logging in..." : "Login"}
      </button>
    </form>

    <p className="mt-6 text-center text-text-secondary">
      Don't have an account?{" "}
      <Link
        to="/register"
        className="text-accent-cyan hover:text-accent-bright-cyan font-semibold"
      >
        Register
      </Link>
    </p>
  </div>
</div>

    </>
  )
}
